import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import CostCenterDefaults from './CostCenterDefaults';
import CostCenterTable from './CostCenterTable';
import { CenterCostSectionCode } from '../../../types/Accounting/CenterCost/CenterCostTypes';
import CenterCostSection from '../../../types/Accounting/CenterCost/CenterCostSection';

const SwitchCostCenter: React.FC<RouteComponentProps<{ section: CenterCostSectionCode }>> = ({ match }) => {
  const {
    params: { section },
  } = match;

  const centerCostSection = new CenterCostSection(section);
  const centerCostType = centerCostSection.centerCostType();

  if (centerCostType) {
    return <CostCenterTable centerCostSection={centerCostSection} centerCostType={centerCostType} />;
  }
  return <CostCenterDefaults />;
};

export default SwitchCostCenter;
